import { render, staticRenderFns } from "./chat-view.vue?vue&type=template&id=e833f3e8&"
import script from "./chat-view.vue?vue&type=script&lang=js&"
export * from "./chat-view.vue?vue&type=script&lang=js&"
import style0 from "./chat-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports